import axios from "axios";
import { auth } from "./authService"; // Importiamo auth per usare AuthRefreshToken

// 1. Configurazione globale per i cookie (fondamentale per il tuo backend C#)
axios.defaults.withCredentials = true;

// Variabili per gestire il refresh in corso e la coda delle richieste
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 2. Controllo Errore 401 (Unauthorized)
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      
      if (isRefreshing) {
        // Se c'è già un refresh in corso, accodiamo questa richiesta
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Chiamata alla funzione di refresh (che modificheremo nello Step 2)
        const newToken = await auth.AuthRefreshToken(); // Questa ora restituisce la stringa corretta
  
          if (!newToken) {
            console.error("ERRORE: Il token ricevuto è undefined!");
            throw new Error("No token");
          }
        
        isRefreshing = false;
        
       // 1. Aggiorniamo l'header di default per TUTTE le chiamate future
        axios.defaults.headers.common["Authorization"] = "Bearer " + newToken;

        // 2. AGGIORNAMENTO CRITICO: Iniettiamo il token direttamente nella richiesta fallita
        originalRequest.headers["Authorization"] = "Bearer " + newToken;

        processQueue(null, newToken);

        // 3. Rieseguiamo la richiesta originale con gli headers aggiornati
        return axios(originalRequest);
      } catch (refreshError) {
        isRefreshing = false;
        processQueue(refreshError, null);

        // SE LA RICHIESTA ORIGINALE ERA UN LOGOUT, NON MOSTRARE L'ALERT!
        // L'utente se ne sta già andando, puliamo e basta.
        if (originalRequest.url.includes("logout")) {
          auth.AuthLogout(false);
          window.location.href = "/login"; 
          return Promise.reject(refreshError);
        }
        const serverMessage = refreshError.response?.data;
        if (serverMessage === "No refresh token found") {
          alert("Sessione scaduta: per continuare è necessario effettuare nuovamente il login.");
        } else {
          alert("Errore durante l'aggiornamento della sessione. Effettua il login.");
        }
        auth.AuthLogout(false);
        window.location.href = "/login"; 
        return new Promise(() => {});
      }
    }

    // 3. Gestione errori generici (Licenza, etc.)
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

      if (expectedError) {
        if (error.response.data === "Licenza SCADUTA contattare info@cicass.it") {
          window.location.href = "/license";
        } 
        // 🔥 SALTA l'alert per i 400 (gestiti dai componenti)
        else if (error.response.status === 400) {
          // Logga ma NON mostrare alert => Vanno gestiti nella pagina !!!!
          console.warn("Errore di validazione (400):", error.response.data);
        } 
        else if (error.response.status !== 401) {
          // Mostriamo l'alert solo se non è un errore di autorizzazione (già gestito sopra)
          alert("Attenzione: " + (error.response.data || "Errore di comunicazione"));
        }
      }

        return Promise.reject(error);
  }
);

function setJwt(jwt) {
  axios.defaults.headers.common["Authorization"] = jwt;
}

function checkHeader(jwt, clientInfo) {
  if (axios.defaults.headers.common["Authorization"] === undefined) 
    axios.defaults.headers.common["Authorization"] = jwt;
  if (axios.defaults.headers.common["From"] === undefined) 
    axios.defaults.headers.common["From"] = clientInfo;
}

function setClientInfo(clientInfo) {
  if (axios.defaults.headers.common["From"] === undefined) {
    axios.defaults.headers.common["From"] = clientInfo;
  }
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
  checkHeader,
  setClientInfo,
};